import { ICellRendererParams } from 'ag-grid-enterprise';

// Default: tick for truthy values, cross for falsy non-void values, empty for
// void values.
export interface TickCrossRendererParams extends ICellRendererParams {
  config?: {
    noCross?: boolean;
    crossForVoid?: boolean;
  };
}

export enum TickCrossValue {
  tick = 'tick',
  cross = 'cross',
  empty = 'empty',
}

export function tickCrossValue(
  value: unknown,
  config: TickCrossRendererParams['config'],
): TickCrossValue {
  if (config?.noCross) {
    // Tick for truthy values, empty otherwise
    return value ? TickCrossValue.tick : TickCrossValue.empty;
  }
  if (config?.crossForVoid) {
    // Tick for truthy values, cross otherwise
    return value ? TickCrossValue.tick : TickCrossValue.cross;
  }
  // Tick for truthy values, empty for void values, cross otherwise
  if (value) {
    return TickCrossValue.tick;
  }
  if (value === null || value === undefined) {
    return TickCrossValue.empty;
  }
  return TickCrossValue.cross;
}
